import { RecordViewBody } from '../record-view-body.js'

/**
 * ox-record-view-body 의 keydown handler
 *
 * - handler의 this 는 ox-record-view-body임.
 */
export async function recordViewBodyKeydownHandler(this: RecordViewBody, e: Event): Promise<void> {
  switch ((e as KeyboardEvent).key) {
    case 'Esc':
    case 'Escape':
    /* TODO 편집이 취소되어야 한다. */
    case 'Enter':
      /* 먼저, focus를 옮겨놓아야, focusout 으로 인해서 popup이 닫히는 것을 방지할 수 있다. */
      this.focus()

      if (this.currentTarget) {
        this.currentTarget.removeAttribute('editing')
      }

      this.currentTarget = null

      break
    default:
  }
}
